export const authMixin = {
  computed: {
    inAdmin () {
      return this.$route.path.includes('beheer')
    }
  },
  methods: {
    isAdmin (account) {
      if (account && account.scopes) {
        return account.scopes.find(scope => scope.id === 1)
      }

      return false
    },
    inScope (account, scopeId) {
      if (account && account.scopes) {
        return account.scopes.find(scope => scope.id === scopeId)
      }

      return false
    },
    hasGrant (account, scopeId) {
      if (this.isAdmin(account)) {
        return true
      }

      return this.inScope(account, scopeId)
    }
  }
}

export const filterMixin = {
  methods: {
    filteredDatasets (datasets, filters) {
      if (filters.length === 0) return datasets

      const flatFilters = filters.flatMap(x => x.filter)

      return datasets.filter((dataset) => {
        const valueIds = dataset.column_values.flatMap(x => x.value_id)

        return flatFilters.every(filter => valueIds.indexOf(filter) >= 0)
      })
    }
  }
}
